/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUmbrella: {
  name: 'umbrella';
  data: string;
} = {
  name: 'umbrella',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.519 7.5H14.48a6.5 6.5 0 0 0-12.962 0ZM15 8.5H8.5V13a1.5 1.5 0 0 0 3 0 .5.5 0 0 1 1 0 2.5 2.5 0 0 1-5 0V8.5H1A.5.5 0 0 1 .5 8a7.5 7.5 0 1 1 15 0 .5.5 0 0 1-.5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
